module.exports = __webpack_public_path__ + "img/物联网设备云平台.3d8bc6cd.png";